export enum Granularity {
	Minutes = 'MINUTES',
	Tenths = 'TENTHS',
	Quarters = 'QUARTERS',
	Hours = 'HOURS',
	Days = 'DAYS',
}

export function getLabelFromGranularity(granularity: Granularity): string {
	switch (granularity) {
		case Granularity.Minutes:
			return '1 minute';
		case Granularity.Tenths:
			return '6 minutes';
		case Granularity.Quarters:
			return '15 minutes';
		case Granularity.Hours:
			return '1 hour';
		case Granularity.Days:
			return '1 day';
	}
}

export function getShortLabelFromGranularity(granularity: Granularity): string {
	switch (granularity) {
		case Granularity.Minutes:
			return 'minute';
		case Granularity.Tenths:
			return 'tenth of an hour';
		case Granularity.Quarters:
			return 'quarter';
		case Granularity.Hours:
			return 'hour';
		case Granularity.Days:
			return 'day';
	}
}

export function getGranularityInfoLabel(granularity: Granularity): string {
	const labelStart = 'Time entries round up to ';
	switch (granularity) {
		case Granularity.Minutes:
			return labelStart + 'the next minute';
		case Granularity.Tenths:
			return labelStart + 'the next tenth of an hour';
		case Granularity.Quarters:
			return labelStart + 'the next quarter';
		case Granularity.Hours:
			return labelStart + 'the next hour';
		case Granularity.Days:
			return labelStart + 'match your working hours';
	}
}
